import { RichText } from 'components/shared';
import { useState } from 'react';
import richTextOptions from './richTextOptions';

const PageTabs = ({
  data: {
    articlesCollection: { items: articles },
  },
}) => {
  const [activePage, setActivePage] = useState(0);

  const hasTabs = articles.length > 1;

  return (
    <section className="lg:relative lg:grid lg:grid-cols-[1fr,max(45%,650px),1fr]">
      {hasTabs && (
        <nav className="px-[30px] pt-[50px] lg:py-[80px] lg:pl-[45px] lg:pr-[12px]">
          <ul className="flex flex-col">
            {articles.map(
              (p, index) =>
                p && (
                  <li key={p.name} className="leading-[1.2]">
                    <button
                      type="button"
                      onClick={() => setActivePage(index)}
                      className={`text-left font-nimbus-sans-extd-d text-[14px] font-bold uppercase hover:underline ${
                        index === activePage ? 'underline' : ''
                      }`}
                    >
                      {p.title}
                    </button>
                  </li>
                )
            )}
          </ul>
        </nav>
      )}
      <article
        className={`py-[30px] px-[30px] text-[14px] text-blue lg:py-[80px] ${
          !hasTabs ? 'col-start-2' : ''
        }`}
      >
        {articles.map(
          (p, index) =>
            p && (
              <div
                key={p.name}
                className={`font-nimbus-sans-d text-[15px] leading-[1.4] ${
                  index !== activePage ? 'hidden' : ''
                }`}
              >
                <RichText data={p.article} options={richTextOptions(p.article)} />
              </div>
            )
        )}
      </article>
    </section>
  );
};

export default PageTabs;
